// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"60f0bcbc","147":"974d13c7","262":"974d13c7","348":"974d13c7","411":"974d13c7","414":"974d13c7","949":"cb98db6f"}[chunkId] + ".chunk.css";
};